import React from 'react';

import { ProductName } from '../product-name';
import Rating from '@prisjakt/ui-rating';

import { BaseProps } from '../../types';
import { CountTranslation } from '@prisjakt/ui-rating/src/types';

const RATING_TRANSLATION = {
  domain: 'product',
  key: 'product-card.n-ratings',
} as CountTranslation;

type Props = Pick<
  BaseProps,
  'name' | 'rating' | 'highlightedName' | 'reviewCount'
>;

export const CompactListCardProductContent: React.FC<Props> = props => {
  const { name, rating, highlightedName, reviewCount } = props;

  return (
    <div>
      <ProductName>{highlightedName || name}</ProductName>

      {rating && rating > 0 ? (
        <Rating
          rate={rating}
          singleStar
          showRate
          showCounter
          count={reviewCount}
          countTranslation={RATING_TRANSLATION}
          size="small"
        />
      ) : null}
    </div>
  );
};
